import { Button } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import * as Styled from './styled';
import type { AuthProps } from './types';

export const Auth: FC<AuthProps> = (props) => {
  const { joinBuyerForm, loginForm, chosenAuth, onChosenAuthChange } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      {/* <Styled.ImageWrapper>
        <img src={dogHi} alt="" />
      </Styled.ImageWrapper> */}
      {!chosenAuth && (
        <>
          <Styled.Section>
            <Styled.Subsection>
              <Styled.Subtitle>{translate('application.steps.auth.signupTitle')}</Styled.Subtitle>
              <Styled.Text>{translate('application.steps.auth.signupText')}</Styled.Text>
              <Button
                shrink
                color="blue"
                size="large"
                onClick={() => onChosenAuthChange?.('register')}
              >
                {translate('common.buttons.register')}
              </Button>
            </Styled.Subsection>

            <Styled.Subsection>
              <Styled.Text>{translate('signup.alreadyHasAccount')}</Styled.Text>
              <Button
                shrink
                color="blue"
                outlined
                size="large"
                onClick={() => onChosenAuthChange?.('login')}
              >
                {translate('common.buttons.login')}
              </Button>
            </Styled.Subsection>
          </Styled.Section>
        </>
      )}
      {!!chosenAuth && (
        <Styled.Section>
          <Styled.Subsection>
            <Styled.BackButtonWrapper>
              <Button
                size="large"
                iconLeft={<FaChevronLeft />}
                onClick={() => onChosenAuthChange?.(undefined)}
              >
                {translate('common.buttons.back')}
              </Button>
            </Styled.BackButtonWrapper>
            {chosenAuth === 'login' && (
              <Styled.FormWrapper>
                <Styled.Subtitle>{translate('common.buttons.login')}</Styled.Subtitle>
                {loginForm}
              </Styled.FormWrapper>
            )}
            {chosenAuth === 'register' && (
              <Styled.FormWrapper>
                <Styled.Subtitle>{translate('common.buttons.register')}</Styled.Subtitle>
                {joinBuyerForm}
              </Styled.FormWrapper>
            )}
          </Styled.Subsection>
        </Styled.Section>
      )}
    </Styled.Wrapper>
  );
};
